export const LAUNCH_HOLD_UNTIL_MODAL = 'LAUNCH_HOLD_UNTIL_MODAL';
export const LAUNCH_REMOVE_HOLD_MODAL = 'LAUNCH_REMOVE_HOLD_MODAL';
export const HOLD_UNTIL = 'HOLD_UNTIL';
export const HOLD_UNTIL_MODAL_CLOSED = 'HOLD_UNTIL_MODAL_CLOSED';
export const SET_IS_LOADING = 'SET_IS_LOADING';

export const launchHoldUntilModal = (fulfillmentPlanIds) => ({
  type: LAUNCH_HOLD_UNTIL_MODAL,
  fulfillmentPlanIds,
});

export const launchRemoveHoldModal = (fulfillmentPlanIds, showNumberOfOrders) => ({
  type: LAUNCH_REMOVE_HOLD_MODAL,
  fulfillmentPlanIds,
  showNumberOfOrders,
});

export const holdUntil = (holdUntilDate) => ({
  type: HOLD_UNTIL,
  holdUntilDate,
});

export const holdUntilModalClosed = () => ({ type: HOLD_UNTIL_MODAL_CLOSED });

export const setIsLoading = (isLoading) => ({
  type: SET_IS_LOADING,
  isLoading,
});
